import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/**
 * Uppercases text as the user types. Applied globally to text inputs.
 * Opt out with `losNoUppercase` or `noUppercase`.
 */
@Directive({
  selector:
    'input[type=text]:not([losNoUppercase]):not([noUppercase]):not([readonly]), input:not([type]):not([losNoUppercase]):not([noUppercase]):not([readonly])',
  standalone: true,
})
export class UppercaseInputDirective {
  private readonly element = inject(ElementRef<HTMLInputElement>);

  @HostListener('input')
  onInput(): void {
    this.applyUppercase();
  }

  @HostListener('paste')
  onPaste(): void {
    queueMicrotask(() => this.applyUppercase());
  }

  private applyUppercase(): void {
    const input = this.element.nativeElement;
    if (input.disabled || input.readOnly) {
      return;
    }

    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const upper = input.value.toUpperCase();

    if (upper === input.value) {
      return;
    }

    input.value = upper;
    input.setSelectionRange(start, end);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
